import config from 'config';
import Pusher from 'pusher-js';
import api from 'api';
import { invalidateRequests } from 'redux-bees';

const jobListeners = {};
let oldAccountId = null;

export function listenToJobResult(id, callback) {
  jobListeners[id] = jobListeners[id] || [];
  jobListeners[id].push(callback);
}

export default function listenToPushEvents(store) {
  const { session } = store.getState();

  if (!session.account) { return; }

  const accountChannelId = `private-account-${session.account.id}`;

  if (accountChannelId !== oldAccountId) {
    oldAccountId = accountChannelId;

    const pusher = new Pusher(
      config.pusher.apiKey,
      {
        cluster: config.pusher.cluster,
        authEndpoint: `${config.apiBaseUrl}/pusher_auth`,
        auth: {
          headers: {
            Authorization: `Bearear ${session.accessToken}`,
          },
        },
      },
    );

    const accountChannel = pusher.subscribe(accountChannelId);

    accountChannel.bind('jobResult', ({ jobId, status, payload }) => {
      if (jobListeners[jobId]) {
        jobListeners[jobId].forEach(cb => cb(status, payload));
      }
    });

    accountChannel.bind('siteStatusChange', ({ siteId }) => {
      if (siteId !== undefined) {
        store.dispatch(api.getSite({ id: siteId }));
      }
    });

    accountChannel.bind('deployStatusChange', ({ siteId, deployId }) => {
      store.dispatch(api.getDeploy({ siteId, id: deployId }));
      store.dispatch(invalidateRequests(api.getBackups, params => params.siteId === siteId));
      store.dispatch(api.getBackups({ siteId }));
    });

    accountChannel.bind('backupStatusChange', ({ siteId, backupId }) => {
      store.dispatch(api.getBackup({ siteId, id: backupId }));
    });

    accountChannel.bind('backupsStatusChange', ({ siteId }) => {
      store.dispatch(invalidateRequests(api.getBackups, params => params.siteId === siteId));
      store.dispatch(api.getBackups({ siteId }));
    });

    accountChannel.bind('logEventAdded', () => {
      store.dispatch(invalidateRequests(api.getLogs));
      store.dispatch(api.getLogs());
    });

    accountChannel.bind('deployLog', ({ siteId, deployId }) => {
      const logId = `${deployId}-log`;
      const { content } = store.getState().bees.entities.log[logId].attributes;

      api.getDeployLog({ siteId, id: deployId, offset: content.split('\n').length })
        .then((payload) => {
          const newContent = payload.body.data.attributes.content;

          if (!newContent) {
            return;
          }

          store.dispatch(
            {
              type: 'api/getDeployLog/response',
              payload: {
                ...payload,
                body: {
                  data: {
                    ...payload.body.data,
                    attributes: {
                      content: `${content}\n${newContent}`,
                    },
                  },
                },
              },
              meta: {
                api: true,
                name: 'getDeployLog',
                params: [{ siteId, id: logId }],
                type: 'response',
              },
            },
          );
        });
    });

    accountChannel.bind('importLog', ({ siteId }) => {
      store.dispatch(invalidateRequests(api.getSiteImport, [{ siteId }]));
    });
  }
}



// WEBPACK FOOTER //
// ./app/sideEffects/pusher.js